import { Badge, Dropdown } from 'react-bootstrap';
import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import SmsDetailModal from '../../layouts/Campaign/Overview/SmsDetailModal';
import { Link } from 'react-router-dom';
import { sortByDate } from '../../helpers/helperFunction';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const AdminCampaignDatatable = ({ dateRange, data }) => {
  const [isActive, setIsActive] = useState(false);
  const [activeRow, setActiveRow] = useState(null);

  const [smsDetailShow, setSmsDetailShow] = useState(false);
  const [campaignId, setCampaignId] = useState('');

  const getStatusBadge = (status) => {
    let style = {};

    switch (status) {
      case 'completed':
        style = { color: '#1faf38', background: 'rgba(31,175,56,0.2)' };
        break;
      case 'failed':
        style = { color: '#de0d19', background: 'rgba(222,13,25,0.2)' };
        break;
      case 'draft':
        style = { color: '#b3b3b3', background: 'rgba(179,179,179,0.2)' };
        break;
      case 'in_progress':
        style = { color: '#1bf907', background: 'rgba(27,249,7,0.2)' };
        break;
      case 'incomplete':
        style = { color: '#f15a24', background: 'rgba(241,90,36,0.2)' };
        break;
      case 'scheduled':
        style = { color: '#ffa047', background: 'rgba(255,160,71,0.2)' };
        break;
      default:
        style = {};
    }

    return (
      <Badge style={style}>
        {status === 'In Progress' ? 'In-Progress' : status === 'Incomplete' ? 'Incomplete' : status}
      </Badge>
    );
  };

  const openSmsDetailModal = (id) => {
    setSmsDetailShow(true);
    setCampaignId(id);
  }

  const sortFn = (valueA, valueB) => {
    if (valueA > valueB) {
      return 1;
    }
    return -1;
  };

  const sortCost = (rowA, rowB) => {
    return sortFn(rowA.campaign_cost, rowB.campaign_cost)
  }

  const sortSms = (rowA, rowB) => {
    return sortFn(rowA.message_count, rowB.message_count)
  }

  const columns = [
    { name: 'Name', sortable: true, minWidth: '150px', selector: (row) => row.user_name },
    { name: 'Email', sortable: true, minWidth: '150px', selector: (row) => row.user_email },
    { name: 'User ID', sortable: true, minWidth: '150px', selector: (row) => row.user_id },
    {
      name: 'Status',
      sortable: true,
      minWidth: '150px',
      selector: (row) => getStatusBadge(row.campaign_status),
    },
    {
      name: 'Campaign Name',
      sortable: true,
      minWidth: '150px',
      selector: (row) => row.campaign_name,
    },
    { name: 'Campaign ID', sortable: true, minWidth: '150px', selector: (row) => row.campaign_id },
    { name: 'Type', sortable: true, minWidth: '150px', selector: (row) => row.campaign_type },
    {
      name: 'Mobile Number',
      sortable: true,
      selector: (row) => <Link onClick={() => openSmsDetailModal(row.campaign_id)}>Details</Link>,
    },
    { name: 'Created Time', sortable: true, selector: (row) => row.created_time, sortFunction: sortByDate('created_time') },
    { name: 'Scheduled Time', sortable: true, selector: (row) => row.scheduled_time, sortFunction: sortByDate('scheduled_time') },
    { name: 'Total Message Sent', sortable: true, selector: (row) => row.total_sms },
    { name: 'Total Recipients', sortable: true, selector: (row) => row.total_contacts },
    ...(!white_label_perkeso ? [
      { name: 'Campaign Cost', sortable: true, sortFunction: sortCost, selector: (row) => row.campaign_cost }
    ]: []),
    { name: 'Message Count', sortable: true, sortFunction: sortSms, selector: (row) => row.message_count },
  ];

  const handleToggleOpen = (state, row) => {
    setIsActive(state);
    if (state) {
      setActiveRow(row.id);
    } else {
      setActiveRow(null);
    }
  };

  return (
    <div className='h-100'>
      <DataTable
        columns={columns}
        data={data}
        className="custom-datatable"
        pagination
        paginationComponentOptions={{
          rowsPerPageText: 'Items per page:',
        }}
      />
      <SmsDetailModal
        campaignId={campaignId}
        show={smsDetailShow}
        setCampaignId={setCampaignId}
        setSmsDetailShow={setSmsDetailShow}
        dateRange={dateRange}
      />
    </div>
  );
}

export default AdminCampaignDatatable;
